<template>
  <spinner :class="{'full-loading': backdrop}" :message="message"></spinner>
</template>
<script>
import spinner from "vue-simple-spinner";
import config from "../../config";

export default {
  name: "socket",
  data() {
    return {
      loading: false,
      socket: ""
    };
  },
  props: ["backdrop", "message", "paymentId"],
  components: {
    spinner
  },
  methods: {
    openSocket() {
      const env = config.env;
      const wsURI = config[env].webSocketURI;
      return new WebSocket(wsURI);
    },
    onMessage(response) {
      console.log("SocketResponse: "+response);
      let data = JSON.parse(response);
      if (data.status === "00") {
        this.$emit("paymentSuccessful");
      } else {
        this.$emit("paymentError", data.message);
      }
    },
    onError(response) {
      let data = JSON.parse(response);
      this.$emit("paymentError", data.message);
    },
    onClose() {
      this.$emit("connectionClosed");
    },
    closeSocket() {
      this.socket.close();
    }
  },
  mounted: function() {
    let socket = this.openSocket();
    socket.onopen = function() {
      console.log("WebSocket connection opened");
      socket.send(this.paymentId);
      this.socket = socket;
    }.bind(this);
    socket.onmessage = function(event) {
      console.log("WebSocket message");
      this.onMessage(event.data);
    }.bind(this);
    socket.onerror = function(event) {
      console.log("WebSocket error: "+event.data);
      this.onError(event);
    };
    socket.onclose = function() {
      console.log("WebSocket connection closed");
      this.onClose();
    }.bind(this);
  },
  beforeDestroy: function() {
    this.closeSocket();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/websocket/Socket.vue